import React, { useEffect, useState } from "react";

import * as Icon from "react-feather";


const getUserRole = () => {
  
  const storedUserData = localStorage.getItem("user");
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    return userData?.data?.role.roleName || "";
  }
  return "";
};

// Create a function that returns menu items based on role
const getMenuItems = (role) => {
  if (role === "Sales Manager") {
    return [
      {
        label: "Sales",
        submenuOpen: true,
        submenuHdr: "Sales",
        submenu: false,
        showSubRoute: false,
        submenuItems: [
          { 
            label: "Invoices", 
            link: "/invoices-list", 
            icon: <Icon.FileText />, 
            showSubRoute: false, 
            submenu: false 
          },
          { 
            label: "Quotation", 
            link: "/quotation-list", 
            icon: <Icon.Save />, 
            showSubRoute: false, 
            submenu: false 
          },
        ]
      }
    ];
  }

  // Return full menu for other roles
  return [
    {
      label: "Main",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Dashboard",
          icon: <Icon.Grid />,
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            { label: "Admin Dashboard", link: "/" },
          ],
        },
      ],
    },
    {
      label: "Jobs",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Jobs",
      submenuItems: [
        {
          label: "Jobs ",
          link: "/jobs",
          icon: <Icon.Briefcase />,
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Services",
          link: "/jobs-types",
          icon: <Icon.Copy />,
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Body Types",
          link: "/body-types",
          icon: <Icon.Type />,
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Styles",
          link: "/styles",
          icon: <Icon.Tag />,
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    {
      label: "Inventory",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Jobs",
      submenuItems: [
        { label: "Brands", link: "/brand-list", icon: <Icon.Tag />, showSubRoute: false, submenu: false },
        { label: "Units", link: "/units", icon: <Icon.Speaker />, showSubRoute: false, submenu: false },
        {
          label: "Category",
          link: "/category-list",
          icon: <Icon.Codepen />,
          showSubRoute: false,
          submenu: false
        },
        { label: "Products", link: "/product-list", icon: <Icon.Box />, showSubRoute: false, submenu: false },
        { label: "GRN", link: "/grn", icon: <Icon.Box />, showSubRoute: false, submenu: false },
        { label: "Issuance", link: "/issuance", icon: <Icon.Box />, showSubRoute: false, submenu: false },
      ]
    },
    {
      label: "Stock",
      submenuOpen: true,
      submenuHdr: "Stock",
      submenu: true,
      showSubRoute: false,
      submenuItems: [
        { label: "Manage Stock", link: "/manage-stocks", icon: <Icon.Package />, showSubRoute: false, submenu: false },
        {
          label: "Stock Adjustment",
          link: "/stock-adjustment",
          icon: <Icon.Clipboard />,
          showSubRoute: false,
          submenu: false
        },
        { label: "Stock Transfer", link: "/stock-transfer", icon: <Icon.Truck />, showSubRoute: false, submenu: false }
      ]
    },
    {
      label: "Sales",
      submenuOpen: true,
      submenuHdr: "Sales",
      submenu: false,
      showSubRoute: false,
      submenuItems: [
        { label: "Invoices", link: "/invoices-list", icon: <Icon.FileText />, showSubRoute: false, submenu: false },
        { label: "Quotation", link: "/quotation-list", icon: <Icon.Save />, showSubRoute: false, submenu: false },
      ]
    },
    {
      label: "Finance & Accounts",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Finance & Accounts",
      submenuItems: [
        {
          label: "Expenses",
          submenu: true,
          showSubRoute: false,
          icon: <Icon.FileText />,
          submenuItems: [
            { label: "Expenses", link: "/expense-list", showSubRoute: false },
            {
              label: "Expense Category",
              link: "/expense-category",
              showSubRoute: false,
            },
          ],
        },
      ],
    },
    {
      label: "People",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "People",
      submenuItems: [
        {
          label: "Customers",
          link: "/customers",
          icon: <Icon.User />,
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Suppliers",
          link: "/suppliers",
          icon: <Icon.Users />,
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    {
      label: "HRM",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "HRM",
      submenuItems: [
        {
          label: "Employees",
          link: "/employees-grid",
          icon: <Icon.Users />,
          showSubRoute: false,
        },
        {
          label: "Departments",
          link: "/department-grid",
          icon: <Icon.User />,
          showSubRoute: false,
        },
        {
          label: "Designations",
          link: "/designation",
          icon: <Icon.UserCheck />,
          showSubRoute: false,
        },
        {
          label: "Shifts",
          link: "/shift",
          icon: <Icon.Shuffle />,
          showSubRoute: false,
        },
      ],
    },
    {
      label: "Reports",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Reports",
      submenuItems: [
        {
          label: "Inventory Report",
          link: "/inventory-report",
          icon: <Icon.Inbox />,
          showSubRoute: false,
        },
        {
          label: "Invoice Report",
          link: "/invoice-report",
          icon: <Icon.File />,
          showSubRoute: false,
        },
        {
          label: "Payment Report",
          link: "/payment-report",
          icon: <Icon.DollarSign />,
          showSubRoute: false,
        },
        {
          label: "Profit & Loss",
          link: "/profit-loss-report",
          icon: <Icon.TrendingDown />,
          showSubRoute: false,
        },
      ],
    },
    {
      label: "User Management",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "User Management",
      submenuItems: [
        {
          label: "Users",
          link: "/users",
          icon: <Icon.UserCheck />,
          showSubRoute: false,
        },
        {
          label: "Roles & Permissions",
          link: "/roles-permissions",
          icon: <Icon.UserCheck />,
          showSubRoute: false,
        },
      ],
    },
    {
      label: "Promotions",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Promotions",
      submenuItems: [
        {
          label: "SMS",
          link: "/sms",
          icon: <Icon.Smartphone />,
          showSubRoute: false,
        },
        {
          label: "Email",
          link: "/send-email",
          icon: <Icon.Smartphone />,
          showSubRoute: false,
        },
        
      ],
    },
    {
      label: "Settings",
      submenu: true,
      showSubRoute: false,
      submenuHdr: "Settings",
      submenuItems: [
        {
          label: "General Settings",
          submenu: true,
          showSubRoute: false,
          icon: <Icon.Settings />,
          submenuItems: [
            { label: "Profile", link: "/general-settings" },
            { label: "Security", link: "/security-settings" },
            { label: "Notifications", link: "/notification" },
            { label: "SMS Templates", link: "/sms-templates" },
            { label: "Email Templates", link: "/email-templates" }
          ],
        },
      ],
    },
  ];
};


const useSidebarData = () => {
  const [sidebarData, setSidebarData] = useState(() => {
    const role = getUserRole();
    return getMenuItems(role);
  });

  useEffect(() => {
    
    const handleStorageChange = () => {
      const role = getUserRole();
      setSidebarData(getMenuItems(role));
    };

   
    window.addEventListener('storage', handleStorageChange);
    
    
    window.addEventListener('userChanged', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userChanged', handleStorageChange);
    };
  }, []);

  return sidebarData;
};


export { useSidebarData };


export const SidebarData = getMenuItems(getUserRole());
